(() => {
  const formSelector = '.olitans-home-quick-add';
  const loadingClass = 'is-loading';

  const getCartAddUrl = () => {
    if (typeof getShopifyAjaxRoute === 'function') {
      return getShopifyAjaxRoute(window.routes?.cart_add_url, 'cart/add.js');
    }

    return '/cart/add.js';
  };

  const parseJsonResponse = (response) => response.text().then((text) => {
    let data;

    try {
      data = text ? JSON.parse(text) : {};
    } catch (error) {
      const friendlyError = new Error('Cart request failed. Please refresh the page and try again.');
      friendlyError.cause = error;
      friendlyError.responseText = text?.slice(0, 120);
      throw friendlyError;
    }

    if (!response.ok) {
      const message = data?.description || data?.message || 'Cart request failed. Please try again.';
      const requestError = new Error(message);
      requestError.data = data;
      throw requestError;
    }

    return data;
  });

  const getCart = () => new Promise((resolve, reject) => {
    if (window.Shopify && typeof Shopify.getCart === 'function') {
      Shopify.getCart(resolve, reject);
      return;
    }

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(parseJsonResponse)
      .then(resolve)
      .catch(reject);
  });

  const updateCartCount = (cart) => {
    if (!cart) return;

    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count >= 100 && window.cartStrings?.item_99
        ? window.cartStrings.item_99
        : cart.item_count;
    });

    document.querySelectorAll('[data-cart-text]').forEach((text) => {
      if (!window.cartStrings) return;
      text.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items;
    });
  };

  const showError = (error) => {
    if (typeof showWarning === 'function') {
      console.warn('OLITANS quick add failed', error);
      showWarning('Cart update failed. Please try again.', window.warningTime || 4000);
      return;
    }

    console.warn('OLITANS quick add failed', error);
  };

  const setLoading = (button, isLoading) => {
    if (!button) return;

    button.classList.toggle(loadingClass, isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  const goToProduct = (form, button) => {
    const url = button?.dataset.productUrl || form?.querySelector('.olitans-home-quick-add__button')?.dataset.productUrl;
    if (url) window.location.href = url;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.olitans-home-quick-add__button');
    const form = button?.closest(formSelector);
    if (!button || !form) return;

    if (form.dataset.olitansQuickAddMode !== 'select') return;

    event.preventDefault();
    event.stopPropagation();
    goToProduct(form, button);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(formSelector);
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    if (form.dataset.olitansQuickAddMode === 'select') {
      goToProduct(form);
      return;
    }

    const button = form.querySelector('.olitans-home-quick-add__button');
    if (!button || button.disabled || button.classList.contains(loadingClass)) return;

    const formData = new FormData(form);
    const variantId = formData.get('id');

    setLoading(button, true);

    fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(parseJsonResponse)
      .then((lineItem) => getCart().then((cart) => {
        updateCartCount(cart);

        if (window.sharedFunctions?.updateSidebarCart && document.body.classList.contains('cart-sidebar-show')) {
          window.sharedFunctions.updateSidebarCart(cart);
        }

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        document.dispatchEvent(new CustomEvent('olitans:cart-success', {
          detail: {
            item: lineItem,
            cart,
            variantId: lineItem?.id || variantId
          }
        }));
      }))
      .catch(showError)
      .finally(() => {
        setLoading(button, false);
      });
  }, true);
})();
